module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "bg",
    staticClass: "vvc-tabbar"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canScroll),
      expression: "canScroll"
    }],
    staticClass: "vvc-ctrl-btn btn-left",
    on: {
      "click": function($event) {
        _vm.scroll($event, 'left')
      }
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('div', {
    ref: "container",
    staticClass: "vvc-tabbar-container",
    on: {
      "wheel": function($event) {
        $event.stopPropagation();
        _vm.scroll($event)
      },
      "dragover": function($event) {
        $event.preventDefault();
      }
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('Tab', {
      attrs: {
        "tab": tab,
        "useRouter": _vm.config.useRouter,
        "styleConfig": _vm.config.style
      }
    })
  })), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canScroll),
      expression: "canScroll"
    }],
    staticClass: "vvc-ctrl-btn btn-right",
    on: {
      "click": function($event) {
        _vm.scroll($event, 'right')
      }
    }
  }, [_vm._v(">")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0b05eada!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabbar/src/tabbar.vue
// module id = 607
// module chunks = 0